<template>
  <div>
    <div align="left" class="mt-5">
      <h5 class="h5 mb-3 text-primary font-weight-bold">
        Click2Buy - Tambah Baru
      </h5>
      <b-row>
        <b-col md="6">
          <b-card>
            <label>
              <b>Tambah Product Baru</b>
            </label>
            <b-form-group
              id="fieldset-1"
              label="Pilih Merchant"
              label-for="input-1"
            >
              <vue-multiselect
                id="ajax2"
                open-direction="bottom"
                v-model="merchant"
                data-vv-as="Merchant"
                name="merchant"
                :preserve-search="true"
                :options="dataMerchant"
                placeholder="Type to search Merchant"
                track-by="id"
                label="store_name"
                class="text-capitalize"
                :loading="isLoadingMerchant"
                :searchable="true"
                @search-change="asyncFindArticle"
              >
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <span class="option__title">{{
                      props.option.store_name
                    }}</span>
                  </div>
                </template>
              </vue-multiselect>
              <p
                class="text-danger"
                style="width: 100%; margin-top: 0.25rem; font-size: 80%"
              >
                {{ veeErrors.first("merchant") }}
              </p>
            </b-form-group>
            <b-form-checkbox
              v-show="!prosesCondition"
              id="is_showing"
              v-model="is_showing"
              name="is_showing"
              :value="true"
              :unchecked-value="false"
              :disabled="
                dataShowing.sum_of_showing_data >=
                dataShowing.maximum_number_of_showing_data
              "
              >Tampilkan di userapp ({{ dataShowing.sum_of_showing_data }}/{{
                dataShowing.maximum_number_of_showing_data
              }})</b-form-checkbox
            >
          </b-card>
          <br />
          <b-card v-show="merchant != ''">
            <label>
              <b>Daftar Product</b>
            </label>
            <section v-if="errored">
              <p>
                We're sorry, we're not able to retrieve this information at the
                moment, please try back later
              </p>
            </section>
            <b-table
              v-else
              responsive
              show-empty
              hover
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              :busy="loading"
              :items="items"
              :fields="key"
              :current-page="currentPage"
              :per-page="0"
              :filter="filter"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              head-variant="light"
              class="bg-white"
              filter-debounce="500"
              empty-text="empty"
            >
              <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template v-slot:cell(selected)="{ rowSelected, item, index }">
                <template v-if="rowSelected">
                  <span aria-hidden="true">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="selected_field_true"
                      name="checkbox-1"
                      value="true"
                      class="pointer-off"
                      unchecked-value="false"
                    ></b-form-checkbox>
                  </span>
                  <span class="sr-only">Selected</span>
                </template>
                <template v-else>
                  <span aria-hidden="true">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="selected_field_false"
                      name="checkbox-1"
                      value="true"
                      class="pointer-off"
                      unchecked-value="false"
                    ></b-form-checkbox>
                  </span>
                  <span class="sr-only">Not selected</span>
                </template>
              </template>
            </b-table>

            <b-row class="mx-auto">
              <b-col md="4" class="mx-auto px-0"
                >Total entries {{ totalRows }}</b-col
              >
              <b-col md="4" class="mx-auto"></b-col>
              <b-col md="4" align="right" class="px-0">
                <b-pagination
                  align="right"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-on:change="clickCallback"
                  class="my-0"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card v-show="selected.length >= 1">
            <label>
              <b>Deskripsi Product</b>
            </label>
            <br />
            <b-spinner label="Spinning" v-if="loadingDetail"></b-spinner>
            <p v-else v-html="product_detail.description"></p>
          </b-card>
          <br />
          <b-card v-show="selected.length >= 1">
            <label>
              <b>Foto Utama Product</b>
            </label>
            <br />
            <b-spinner label="Spinning" v-if="loadingDetail"></b-spinner>
            <b-row v-else>
              <b-col md="2">
                <img :src="product_detail.thumbnail" alt="" width="75 px" />
              </b-col>
              <b-col md="2" v-for="variant in variants" :key="variant">
                <img :src="variant.thumbnail" alt="" width="75 px" />
              </b-col>
            </b-row>
          </b-card>
          <br />
          <b-card v-show="selected.length >= 1">
            <label>
              <b v-if="variants.length >= 1">Pilihan Variant</b>
              <b v-else>Tidak Ada Variant</b>
            </label>
            <br />
            <b-spinner label="Spinning" v-if="loadingDetail"></b-spinner>
            <b-card
              v-else
              v-for="variant in variants"
              :key="variant"
              class="my-3"
            >
              <b-row>
                <b-col md="2">
                  <img
                    :src="variant.thumbnail"
                    alt="Img Variant"
                    width="75 px"
                  />
                </b-col>
                <b-col>
                  <label style="cursor: pointer">
                    <b>{{ variant.name }}</b>
                  </label>
                  <br />
                  <label style="cursor: pointer">
                    {{ variant.price }}
                  </label>
                  <br />
                  <!-- <label style="color:#9b9b9b;cursor:pointer">
                                    Weight | Dimension
                                </label> -->
                </b-col>
              </b-row>
            </b-card>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="3">
          <router-link :to="{ name: 'Click2buy' }">
            <b-button block variant="outline-primary" class="py-3"
              >Batal</b-button
            >
          </router-link>
        </b-col>
        <b-col md="3">
          <b-button
            block
            variant="primary"
            class="py-3"
            @click="Click2buy"
            :disabled="validAdd"
          >
            {{ prosesCondition ? "Ubah" : "Tambah" }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedMerchantId:0,
      merchant: "",
      dataMerchant: [],
      isLoadingMerchant: false,
      searchMerchant: "",
      loading: true,
      loadingDetail: true,
      errored: false,
      items: [],
      totalData: 0,
      key: [
        {
          key: "selected",
          label: "",
          class: "text-left",
        },
        {
          key: "product_detail.name",
          label: "Nama Product",
          sortable: true,
          class: "text-center",
        },
        {
          key: "product_detail.variant_total",
          label: "Variant",
          sortable: true,
          class: "text-center",
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      allSelected: false,
      indeterminate: false,
      selected_field_true: true,
      selected_field_false: false,
      selected: [],
      selectedVariant: [],
      unselect: [],
      variants: [],
      product_detail: [],
      is_showing: false,
      dataShowing: "",
      dataByID: "",
    };
  },
  async mounted() {},
  async beforeCreate() {
    if (this.$route.params.id != "-") {
      await this.$store
        .dispatch("CLick2BuyModule/getClick2BuyByID", this.$route.params.id)
        .then((response) => {
          this.dataByID = response.data.data;
          this.is_showing = this.dataByID.is_showing;
          this.isLoadingMerchant = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.isLoadingMerchant = false;
        });
    }
  },
  async created() {
    await this.getAllMerchant("");
    await this.getShowingData();
  },
  computed: {
    validAdd() {
      if (this.merchant != "" && this.selected.length >= 1) {
        return false;
      } else {
        return true;
      }
    },
    prosesCondition() {
      return this.$route.params.id != "-";
    },
  },
  methods: {
    getShowingData() {
      const formData = new FormData();
      formData.append("search_param", "");
      formData.append("limit", 50);
      formData.append("page", 1);
      this.$store
        .dispatch("CLick2BuyModule/infoShowing")
        .then((response) => {
          this.dataShowing = response.data.data;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
    Click2buy() {
      const formData = new FormData();
      formData.append("merchant_id", this.merchant.id);
      formData.append("product_id", this.selected[0].id);
      formData.append("status", this.is_showing ? "show" : "hide");
      const payload = {
        data: formData,
        id: this.$route.params.id,
      };
      const link = this.prosesCondition ? "editClick2Buy" : "postClick2Buy";
      this.$store
        .dispatch(`CLick2BuyModule/` + link, payload)
        .then((response) => {
          this.$router.push({ name: "Click2buy" });
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
    SelectVariant(selected) {
      this.selectedVariant = [];
      this.selectedVariant.push(selected);
    },
    getDetailProduct(id) {
      this.loadingDetail = true;
      const formData = new FormData();
      formData.append("search_param", "");
      formData.append("limit", 50);
      formData.append("page", 1);
      const payload = {
        data: formData,
        id: id,
      };
      this.$store
        .dispatch("CLick2BuyModule/getProductDetailByID", payload)
        .then((response) => {
          this.loadingDetail = false;
          this.product_detail = response.data.data.product_detail;
          this.variants = response.data.data.product_variant;
        })
        .catch((error) => {
          this.loadingDetail = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
    onRowSelected(items) {
      const limit = 1;
      let selected = items;
      let result = items.filter((item) =>
        this.selected.some((select) => item.id === select.id)
      );
      if (items.length > limit) {
        result.forEach((item) => {
          const idx = this.items.findIndex((it) => item == it);
          if (idx >= 0) {
            this.$refs.selectableTable.unselectRow(idx);
          }
        });
      }
      this.selected = items;
      if (selected.length == 1) {
        this.getDetailProduct(selected[0].id);
      }
    },
    toggleAll(checked) {
      this.selected = checked
        ? this.$refs.selectableTable.selectAllRows()
        : this.$refs.selectableTable.clearSelected();
    },
    asyncFindArticle(query) {
      this.isLoadingMerchant = true;
      this.searchMerchant = query;
      this.getWorksAsync();
    },
    getWorksAsync: _.debounce(function () {
      const merchant = this.searchMerchant.toLowerCase();
      this.getAllMerchant(merchant);
    }, 1000),
    getProductByMerchant(id) {
      this.loading = true;
      this.selectedMerchantId = id;
      const payload = {
        limit: this.perPage,
        page: this.currentPage,
        id: id,
      };
      this.$store
        .dispatch("CLick2BuyModule/getProductByMerchantID", payload)
        .then((response) => {
          this.loading = false;
          this.items = response.data.data.products;
          this.totalRows = response.data.data.total;
          this.currentPage = response.data.data.page;
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
    clickCallback: function (pageNum) {
        this.currentPage = Number(pageNum);
        this.getProductByMerchant(this.selectedMerchantId)
    },
    getAllMerchant(search) {
      const formData = new FormData();
      formData.append("search_param", search);
      formData.append("limit", 50);
      formData.append("page", 1);
      this.isLoadingMerchant = true;
      this.$store
        .dispatch("CLick2BuyModule/getAllMerchant", formData)
        .then((response) => {
          this.dataMerchant = response.data.data.merchants;
          this.isLoadingMerchant = false;
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.isLoadingMerchant = false;
        });
    },
  },
  watch: {
    dataByID(newVal, oldVal) {
      if (this.prosesCondition) {
        var data = this.dataMerchant.filter(
          (merchant) => merchant.id == this.dataByID.merchant_id
        );
        this.getProductByMerchant(this.dataByID.merchant_id);
        if (data.length != 0) {
          this.merchant = data.reduce((obj, item) => {
            return obj, item;
          });
        } else {
          this.isLoadingMerchant = true;
        }
      }
    },
    dataMerchant(newVal, oldVal) {
      if (this.prosesCondition) {
        var data = this.dataMerchant.filter(
          (merchant) => merchant.id == this.dataByID.merchant_id
        );
        if (data.length != 0) {
          this.merchant = data.reduce((obj, item) => {
            return obj, item;
          });
        }
      }
    },
    items(newVal, oldVal) {
      if (this.prosesCondition) {
        this.selected = this.items.filter(
          (product) => product.id == this.dataByID.product_id
        );
        var data = this.dataMerchant.filter(
          (merchant) => merchant.id == this.dataByID.merchant_id
        );
        if (data.length == 0) {
          this.dataMerchant.unshift({
            id: newVal[0].merchant.id,
            store_name: newVal[0].merchant.name,
          });
          this.isLoadingMerchant = false;
        }
        const idx = this.items.findIndex((it) => this.selected[0].id == it.id);
        setTimeout(() => {
          this.$refs.selectableTable.selectRow(idx);
        }, 100);
      }
    },
    merchant(newVal, oldVal) {
      this.getProductByMerchant(newVal.id);
    },
  },
};
</script>

<style>
</style>